/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useCallback, useContext, useState, FC } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { H1, P } from './TahoraUI/Typography';
import Layout from './TahoraUI/Layout';
import Header from './Header';
import './layout.css';
import Line from './Line';
import { RichText } from 'prismic-reactjs';
import ShapeA from '../images/Background.svg';
import ShapeB from '../images/pricbg.svg';
import { Switch } from '@headlessui/react';
import ShapeC from '../images/shapes/tick.svg';
import ShapeD from '../images/pricemob.svg';
import { heroContent } from './homePage/HomePageContent';
import Flex, { desktopOnlyDisplay, mobileOnlyDisplay } from './TahoraUI/Flex';
import { RequestDemoContext } from '../context/RequestDemoContext';

const Layout1 = ({
  children,
  bg,
  pricingTitle,
  heroText,
  heroImage,
  overview,
  allPriceInfo,
}) => {
  const [enabled, setEnabled] = useState(true);
  const [content, setContent] = useState({ heroContent });
  const { openModal } = useContext(RequestDemoContext);

  return (
    <Layout>
      {/*    HERO -->
       */}

      {/*<div class="  relative bg-primary-50">
  <main class="lg:relative">
    <div  style={{"maxWidth": "1200px"}}  class="mx-auto flex flex-col lg:flex-row max-w-7xl w-full pt-16 pb-20  lg:py-48 lg:text-left">
      <div class="px-4 lg:w-1/2 sm:px-8 xl:pr-16">
      <div class="mt-28 ml-2">
      <p class="mt-3 workfont2 max-w-md  sm:text-xl uppercase md:mt-5 md:max-w-3xl">{pricingTitle}
        </p>
        <div class="maintitle mx-auto md:mt-5 md:max-w-3xl xl:mr-28">
          {heroText}
        </div>

      </div>
      </div>
      <div class="mt-32 align1 lg:relative sm:max-w-lg  lg:mt-0 lg:max-w-none self-center lg:col-span-6 lg:flex lg:items-center">
         
          <div class="relative mx-auto w-12/12 my-auto rounded-lg shadow-lg lg:max-w-2xl">
            <div class="relative block w-full rounded-lg overflow-hidden focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              <span class="sr-only">Watch our video to learn more</span>
              <img class="w-full" src={heroImage} alt=""/>
              
            </div>
          </div>
        </div>
    </div>
    <div class="backg1 absolute inset-y-0 right-0 moremargin  -z-1 top-2/3 sm:top-1/2 md:top-1/2  w-full h-64   lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 ">
    </div>
  </main>
</div>*/}

      <div className="pricehero mb-24 flex flex-col lg:flex-row relative justify-center">
        <div className="lg:w-1/2 lg:h-full w-full h-1/2 bg-transparent"> </div>
        <div className="lg:w-1/2 lg:h-full w-full h-1/2 backgro"> </div>

        <div className="absolute left-0 right-0 frame mx-auto h-full flex lg:flex-row flex-col justify-center items-center">
          <div className="lg:w-1/2 w-full pb-4 lg:h-full h-1/2 pl-6 bg-transparent lg:pb-0 padmid md:pt-32 pt-0 flex flex-col md:justify-center justify-end items-start">
            <div class="mt-3 workfont2 max-w-md text-left sm:text-xl uppercase md:mt-5 md:max-w-3xl">
              {pricingTitle}{' '}
            </div>
            <div class="maintitle lg:mx-auto md:mt-5 md:w-2/3 md:max-w-xl xl:mr-28">
              {heroText}
            </div>
          </div>
          <div className="lg:w-1/2 w-full lg:h-full h-1/2 backgro flex  justify-center items-center ">
            <div className="lg:-ml-36 lg:mt-28 mainpic flex h-full justify-center items-center">
              <img
                class="herimage  lg:p-0"
                src={heroImage + '?w=900&q=100'}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      {/*<!-- FOUR CARDS -->
       */}
      <div class="pb-12 -mt-16 lg:mt-2 bg-white">
        <div class="wmax mx-auto px-4 sm:px-6 lg:px-4">
          <dl class="space-y-10 lg:space-y-0 ">
            <div class="flex flex-col items-center lg:pt-auto lg:flex-row ml">
              {overview.map((card, i) => {
                return (
                  <div class="summary my-6 mx-4 lg:my-auto w-11/12 pl-4 cards">
                    <div className="cardCopy">
                      <dt>
                        <div class="sectheader">
                          <RichText render={card.tahora_overview_title} />
                        </div>
                      </dt>
                      <div class="sectext text-base">
                        {RichText.asText(card.tahora_overview_content)}
                      </div>
                    </div>
                    <div class="cardImage flex items-center justify-end">
                      {/*            <!-- Heroicon name: outline/globe-alt -->
                       */}{' '}
                      <img
                        style={{ width: '61%' }}
                        src={card.main_card_image.url}
                        alt=""
                      />
                    </div>
                    <div class="cardImage1 flex items-center justify-end">
                      {/*            <!-- Heroicon name: outline/globe-alt -->
                       */}{' '}
                      <img
                        style={{ width: '58%' }}
                        src={card.mobile_card_image.url}
                        alt=""
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </dl>
        </div>
      </div>

      <div class="tprice relative -mt-16 sm:-mt-8 md:-mt-20 lg:mt-16 h-full mx-auto flex flex-col-reverse lg:flex-row">
        <div
          style={{ backgroundColor: '#E5F1F8' }}
          class="h-full md:h-1/2 py-28 lg:py-28  twords1 overflow-hidden flex justify-center  lg:flex lg:items-center  lg:relative lg:h-full w-full lg:w-1/2"
        >
          <div class="absolute right-0 bottom-0 z-0">
            <ShapeB className="priceShape1" />
            <ShapeD className="priceShape2" />
          </div>
        </div>

        <div
          style={{ maxWidth: '47rem' }}
          class="md:h-1/2 twords2 ml-2 lg:mx-auto px-4 pt-auto pb-12 sm:px-6 lg:px-8 lg:py-16"
        ></div>

        <div
          style={{ maxWidth: '1440px' }}
          class=" h-full absolute left-0 right-0 mx-auto flex flex-col-reverse  lg:flex-row"
        >
          <div class="lg:w-1/2 h-full md:h-1/2  my-auto flex justify-center items-center">
            <img
              class="w-9/12 md:w-7/12 lg:w-11/12 z-1 ctaimage"
              src={allPriceInfo.pricing_section_image.url}
              style={{ zIndex: '1' }}
              alt=""
            />
            <img
              class="w-9/12 z-1 ctaimagemobile"
              src={allPriceInfo.pricing_section_image_mobile.url}
              style={{ zIndex: '1' }}
              alt=""
            />
          </div>
          <div
            style={{ maxWidth: '47rem' }}
            class="lg:w-1/2 ml-2 h-full md:h-1/2 lg:h-full mlg:py-28 lg:mx-auto px-4 pt-auto md:flex md:items-center sm:px-6 lg:px-12 lg:py-16"
          >
            <div class="lg:pl-28 pl-2 ">
              <div class="bluecaps1">
                <RichText render={allPriceInfo.pricing_section_title} />
              </div>

              <div class="sectext">
                <RichText render={allPriceInfo.pricing_section_text} />
              </div>
              <div class="mt-8">
                <div
                  onClick={openModal}
                  class="cursor-pointer inline-flex rounded-full border-solid border-2 borderbttn btnText buttonhov1"
                >
                  <div class="inline-flex items-center justify-center  bluenorm px-5 py-3 border border-transparent text-base font-medium rounded-full">
                    <div className=" btnText"> Request a demo</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*<!-- This example requires Tailwind CSS v2.0+ -->*/}
      <div class="">
        <div class="pt-0 flex flex-col justify-center lg:pt-16">
          <div class="max-w-7xl mx-auto text-center flex flex-col justify-center px-4 sm:px-6 lg:px-8">
            <div class="max-w-3xl mx-4 lg:mx-auto space-y-2 flex flex-col justify-center lg:max-w-3xl">
              <div
                style={{ fontWeight: '400', marginTop: '1.5rem' }}
                className="mx-auto bluecaps1 shrinktitle -mt-10 lg:mt-6"
              >
                <RichText render={allPriceInfo.pricing_table_title} />
              </div>
              <p class="submarg text-gray-600 norm mx-auto subshrink lg:text-xl">
                <RichText render={allPriceInfo.pricing_table_subtitle} />
              </p>
            </div>
          </div>
        </div>

        <div>
          <Switch.Group
            as="div"
            className="flex text-gray-600 mt-8 justify-center space-x-4 mx-auto text-2xl sm:text-4xl lg:text-xl"
          >
            <Switch.Label className="norm text-xl">Bill Monthly</Switch.Label>
            <Switch
              as="button"
              checked={enabled}
              onChange={setEnabled}
              className={`${
                enabled ? 'bg-white' : 'bg-white'
              } relative inline-flex flex-shrink-0 h-8 w-14  duration-200 ease-in-out border-2 border-solid border-black rounded-full cursor-pointer focus:outline-none focus:shadow-outline`}
            >
              {({ checked }) => (
                <span
                  className={`${
                    checked ? 'translate-x-6' : 'translate-x-0'
                  } inline-block w-7 h-7 transition duration-200 ease-in-out transform brief3 border-white border-solid border-2 rounded-full`}
                />
              )}
            </Switch>
            <Switch.Label className="norm text-xl ">Bill Annually</Switch.Label>
          </Switch.Group>
        </div>

        <div class="mt-10 pb-12 sm:pb-2 lg:pb-16 lg:mt-16 ">
          <div class="relative">
            <div class="absolute inset-0  "></div>
            <div class="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div class="max-w-md mx-auto lg:max-w-6xl lg:grid lg:grid-cols-3 lg:gap-5 l">
                <div class="flex mb-10 lg:mb-auto px-4 brief1 h-96 flex-col shadow-lg overflow-hidden">
                  <div class="px-4 py-8 brief1  sm:pt-6 sm:pb-6">
                    <H1
                      style={{ fontSize: '40px', color: 'white' }}
                      class="caps mt-4 flex items-baseline text-white"
                    >
                      <RichText render={allPriceInfo.package_1_title} />
                    </H1>
                    <P
                      style={{
                        color: 'white',
                        marginTop: '1.25rem',
                        fontFamily: 'Inter400',
                      }}
                      class="mt-5 text-lg text-white"
                    >
                      <RichText render={allPriceInfo.package_1_subtext} />
                    </P>
                  </div>
                  <div class=" relative flex-1 flex flex-col lg:px-6 px-8 pb-8 brief space-y-6 sm:p-10 sm:pt-0">
                    <ul class="lg:space-y-4 pl-3">
                      <div class="flex-shrink-0"></div>
                      <p class="-ml-5 text-base text-white specific">
                        <RichText render={allPriceInfo.package_1_features} />
                      </p>
                    </ul>
                    <div
                      onClick={openModal}
                      class="cursor-pointer absolute bottom-8 lg:bottom-7 left-0 right-0 rounded-full border-solid w-3/6 justify-center mx-auto border-2 border-white hover:bg-white buttonhov "
                    >
                      <div
                        class="flex items-center justify-center norm py-3 text-base font-medium text-white "
                        aria-describedby="tier-standard"
                      >
                        <div className=" startedText"> Get Started</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex mb-10 lg:mb-0 h-96 brief2 px-4 flex-col shadow-lg overflow-hidden">
                  <div class="px-4 py-8 brief2 sm:pt-6 sm:pb-6">
                    <H1
                      style={{
                        fontSize: '40px',
                        color: 'white',
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                      class="caps mt-4 items-baseline text-white"
                    >
                      <RichText render={allPriceInfo.package_2_title} />
                      {enabled ? <div> - £3</div> : <div> - £4</div>}
                    </H1>
                    <P
                      style={{
                        color: 'white',
                        marginTop: '1.25rem',
                        fontFamily: 'Inter400',
                      }}
                      class="mt-5 text-lg text-white"
                    >
                      <RichText render={allPriceInfo.package_2_subtext} />
                    </P>
                  </div>
                  <div class=" relative flex-1 flex flex-col lg:px-6 px-8 pb-8 brief space-y-6 sm:p-10 sm:pt-0">
                    <ul class="lg:space-y-4 pl-3">
                      <div class="flex-shrink-0"></div>
                      <p class="-mt-1 md:-mt-3 lg:mt-auto  -ml-5 text-base text-white specific">
                        <RichText render={allPriceInfo.package_2_features} />
                      </p>
                    </ul>
                    <div
                      onClick={openModal}
                      class="cursor-pointer absolute bottom-8 lg:bottom-7 left-0 right-0 rounded-full border-solid w-3/6 justify-center mx-auto border-2 border-white hover:bg-white buttonhov "
                    >
                      <div
                        class="flex items-center justify-center norm py-3 text-base font-medium text-white "
                        aria-describedby="tier-standard"
                      >
                        <div className=" startedText"> Get Started</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex brief3 flex-col px-4 h-96 shadow-lg overflow-hidden">
                  <div class="px-4 py-8 brief3 sm:pt-6 sm:pb-6">
                    <H1
                      style={{ fontSize: '40px', color: 'white' }}
                      class="caps mt-4 flex items-baseline text-white"
                    >
                      <RichText render={allPriceInfo.package_3_title} />
                    </H1>

                    <P
                      style={{
                        color: 'white',
                        marginTop: '1.25rem',
                        fontFamily: 'Inter400',
                      }}
                      class="mt-5 text-lg text-white"
                    >
                      <RichText render={allPriceInfo.package_3_subtext} />
                    </P>
                  </div>
                  <div class=" relative flex-1 flex flex-col lg:px-6 px-8 pb-8 brief space-y-6 sm:p-10 sm:pt-0">
                    <ul class="lg:space-y-4 pl-3">
                      {/*<li class="flex items-start">*/}
                      <div class="flex-shrink-0">
                        {/*<!-- Heroicon name: outline/check -->*/}
                      </div>
                      <p class="-mt-1 md:-mt-3 lg:mt-auto -ml-5 text-base text-white specific">
                        <RichText render={allPriceInfo.package_3_features} />
                      </p>
                      {/* </li>*/}
                    </ul>
                    <div
                      onClick={openModal}
                      class="cursor-pointer absolute bottom-8 lg:bottom-7 left-0 right-0 rounded-full border-solid w-3/6 justify-center mx-auto border-2 border-white hover:bg-white buttonhov "
                    >
                      <div
                        class="flex items-center justify-center norm py-3 text-base font-medium text-white "
                        aria-describedby="tier-standard"
                      >
                        <div className=" startedText"> Get In Touch</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-10 relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:mt-20">
            <div class="max-w-md mx-auto lg:max-w-6xl">
              <div class="brief4 px-6 py-8 sm:p-10 lg:flex lg:items-center">
                <div class="flex-1">
                  <div>
                    <H1
                      style={{
                        fontSize: '40px',
                        color: 'white',
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                      class="caps inline-flex  py-1  text-white"
                    >
                      <RichText render={allPriceInfo.addon_title} />
                      <div> - </div>
                      <div>£3</div>
                    </H1>
                  </div>
                  <div class="mt-4 text-lg text-white">
                    <P style={{ color: 'white' }}>
                      <RichText render={allPriceInfo.addon_subtitle} />
                    </P>
                  </div>
                  <div
                    style={{ columnCount: 2 }}
                    class="mt-4 text-lg text-white specific"
                  >
                    <RichText
                      class="listImage"
                      render={allPriceInfo.addon_features}
                    />
                  </div>
                </div>
                <div
                  onClick={openModal}
                  class="cursor-pointer mt-6 rounded-full border-solid mx-auto border-2 border-white w-3/6 lg:w-1/6 shadow lg:mt-0 lg:ml-10 lg:flex-shrink-0 hover:bg-white buttonhov"
                >
                  <div
                    class="flex items-center justify-center norm py-3 text-base font-medium text-white "
                    aria-describedby="tier-standard"
                  >
                    <div className=" startedText"> Get Started</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
        }}
      >
        <main>{children}</main>
      </div>
    </Layout>
  );
};

Layout1.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout1;
